module.exports = __webpack_public_path__ + "img/tfn_logo.eb2405b4.png";